import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classNames from 'classnames';
import { Link, withRouter } from 'react-router-dom';

import normalizeInternalLink from 'commons/normalizeInternalLink';
import IconArrowRightSimple from 'components/icons/iconArrowRightSimple';
import CtaLink from 'components/essentials/Cta/CtaLink';
import ShopPageListItem from './ShopPageListItem';

const ShopPageList = ({
  inspirationPath,
  name,
  path,
  subcategories,
  variant,
}) => (
  <div className="group/ShopPageCategoryPanel__content">
    <Link
      className={classNames(
        'text-xl font-bold text-gary block pb-4 pt-6 px-6 hover:no-underline',
        {
          'md:max-[1023px]:px-0': variant === 'LivingRoom',
        }
      )}
      to={normalizeInternalLink(path)}
    >
      <span>{name}</span>
      <span
        className={classNames(
          'w-8 h-8 bg-gray-light8 inline-flex items-center justify-center ml-2.5 rounded-[32px] relative -top-1 transition-all duration-[0.25s]',
          '[&_svg]:h-3 [&_svg]:left-px [&_svg]:relative [&_svg]:transition-all [&_svg]:duration-[0.25s]',
          // Highlight arrow if the parent Link element is hovered
          '[*:hover>&]:bg-brand [*:hover>&]:[&_svg_path]:stroke-white',
          // Highlight arrow if the image link is hovered
          'group-[a:hover+&]/ShopPageCategoryPanel__content:bg-brand group-[a:hover+&]/ShopPageCategoryPanel__content:[&_svg_path]:stroke-white'
        )}
      >
        <IconArrowRightSimple />
      </span>
    </Link>

    {!!subcategories.length && (
      <div className="mt-4 md:mx-6 text-base font-bold list-none">
        {subcategories.map(({ subcategoryTitle, link, ...subcategory }) => {
          const product =
            get(subcategory, 'products.products.0', []) ||
            get(subcategory, 'products.products.1', []);

          return (
            <ShopPageListItem
              key={subcategoryTitle}
              title={subcategoryTitle}
              product={product}
              link={link}
            />
          );
        })}
      </div>
    )}

    {inspirationPath && (
      <div className="text-sm font-bold text-brand block mt-4 px-6 pb-6 [&_svg]:h-2 [&_svg_path]:fill-brand">
        <CtaLink
          to={inspirationPath}
          color="brand"
          noLinkPadding
          className="hover:!text-brand hover:!no-underline"
        >
          Get {name} Inspiration
        </CtaLink>
      </div>
    )}
  </div>
);

ShopPageList.propTypes = {
  name: PropTypes.string,
  path: PropTypes.string,
  subcategories: PropTypes.shape({
    map: PropTypes.func,
    subcategoryTitle: PropTypes.string,
    link: PropTypes.string,
    length: PropTypes.number,
  }),
  inspirationPath: PropTypes.string,
  variant: PropTypes.oneOf(['LivingRoom']),
};

export default withRouter(ShopPageList);
